import axios from "~/utils/api";

const defaultApi = {
  getDefaultCard: (customerId) => axios.get(`stripe/${customerId}`),
};

export default defaultApi;
